export default {
  paper: {
    maxWidth: '650px',
    minWidth: '544px',
  },
};
